module.exports = __webpack_public_path__ + "static/media/PrevDisabled.4d8ff556.svg";